export function* twitterAuthWorker() {
  yield window.dispatchEvent(new StorageEvent('storage'));
  window.close();
  yield;
}
